module.exports = __webpack_public_path__ + "media/长沙花鼓戏.fe0b2101.wav";